import { LoginService } from './LoginService'
import { SessionCache, AuthService, cachiosFactory } from 'my-account-common'
import { cachiosConfigure } from './axios/axiosConfigurer'

let authService = new AuthService()
let sessionCache = new SessionCache(authService, {key: 'my-login'})
let axiosCache = cachiosConfigure(authService, {ttl: 5, sessionCache: sessionCache}, cachiosFactory)
let loginService = new LoginService(axiosCache)
export { axiosCache as axios, authService, sessionCache, loginService }



// WEBPACK FOOTER //
// ./src/services/ServiceContainer.js